import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	setTipsCommissionMaxValue: (value: Nullable<number>) => void;
}

export const TipsCommissionMaxValueField: React.FC<IProps> = React.memo(({ setTipsCommissionMaxValue }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterMaxValue') }], [t]);

	return (
		<FormInput
			testId="TipsCommissionMaxValueField"
			type="number"
			min={0}
			precision={1}
			name="tipsCommissionMaxValue"
			label="maxValueLabel"
			onChangeNumber={setTipsCommissionMaxValue}
			validationRules={validationRules}
		/>
	);
});
